import { render, staticRenderFns } from "./Newest.vue?vue&type=template&id=4d3b1fde&scoped=true&"
import script from "./Newest.vue?vue&type=script&lang=js&"
export * from "./Newest.vue?vue&type=script&lang=js&"
import style0 from "./Newest.vue?vue&type=style&index=0&id=4d3b1fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3b1fde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
